export const isResourceNotFoundException = (err: any): boolean => {
  try {
    return err.response.data.exceptionType == 'ResourceNotFoundException'
  } catch (e) {
    return false
  }
}

export const isResourceNoResultException = (err: any): boolean => {
  try {
    return err.response.data.exceptionType == 'NoResultException'
  } catch (e) {
    return false
  }
}
